import { ApplicationName } from 'projects/shared/src/lib/core/enums/application-name.enum';
import { EnvironmentName } from 'projects/shared/src/lib/core/enums/environment-name.enum';
import { ProjectName } from 'projects/shared/src/lib/core/enums/project-name.enum';

export const environment = {
  production: false,
  name: EnvironmentName.Test,
  projectName: ProjectName.Bareka,
  version: '1.0.0',
  build: '',
  baseApiUrl: 'https://taranisapi-dev.sensotec.be',
  urlVersion: '/api/v1',
  authorityUrl: 'https://test.lexipoort.nl',
  // TODO: change
  identityClientId: 'Bareka_V3',
  isLegacyWallToggleEnabled: true,
  applicationName: ApplicationName.Bareka,
  azureBlobBaseUrl: 'https://sensotecstrekenappsdev.blob.core.windows.net/assets/',
};
